import React from 'react';
import RotateLoader from 'react-spinners/RotateLoader';

import './LoadingIndicator.scss';
import Colours from '../../styles/common/colours';

const LoadingIndicator = (): React.ReactElement => (
  <div className="loading-indicator">
    <div className="indicator">
      <RotateLoader color={Colours.PrimaryAccent} size="20px" />
    </div>
  </div>
);

export default LoadingIndicator;
